import React from 'react'
import { CrossClientLanding } from './Landing/CrossClientLanding'
import { useZocksAuth, useZocksQuota } from '../../components/ScopedBlock/hooks'
import { CrossClientWaitlist } from './Waitlist/CrossClientWaitlist'
import { useCookies } from 'react-cookie'
import { CrossClientUnauthorized } from './Unauthorized/CrossClientUnauthorized'
import { CrossClientAccessRequired } from './AccessRequired/CrossClientAccessRequired'
import { useGetAccountQuery } from '../../store/accountUserSettings/accountUserSettings'
import { selectAccountId } from '../../store/auth/authSlice'
import { useAppSelector } from '../../store/hooks'

const CROSS_CLIENT_COOKIE = 'omn8xHPqcIjch0vyFWCY'

export const CrossClient: React.FC = () => {
  const { hasQuota, isFetching: quotaIsFetching, quotaSuccess } = useZocksQuota()
  const { hasScope } = useZocksAuth()

  const accountId = useAppSelector(selectAccountId)
  const { data: accountData, isFetching: accountIsFetching } = useGetAccountQuery({ accountId })

  const crossClientAvailable = hasQuota('ai.crossClientQuery.value')
  const hasCrossClientExecutePermission = hasScope('**', 'cross_client_query:execute', ['cross_client_query:admin'])
  const hasCrossClientAdminPermission = hasScope('**', 'cross_client_query:admin', [])

  const [cookies] = useCookies([CROSS_CLIENT_COOKIE])

  if ((!quotaSuccess && quotaIsFetching) || accountIsFetching) {
    return null
  }

  const shouldShowWaitlist = !crossClientAvailable && !cookies[CROSS_CLIENT_COOKIE]

  if (shouldShowWaitlist) {
    return <CrossClientWaitlist />
  }

  if (!hasCrossClientExecutePermission) {
    return <CrossClientUnauthorized />
  }

  if (!hasCrossClientAdminPermission && !accountData?.data?.config?.crossClientQueryUserExecution) {
    return <CrossClientAccessRequired />
  }

  return <CrossClientLanding />
}
